import { cn } from "@/lib/utils";

export function CheckmarkIcon({
  className,
  ...props
}: React.ComponentProps<"svg">) {
  return (
    <svg
      aria-hidden="true"
      className={cn("h-2 w-2.5 text-white", className)}
      viewBox="0 0 10 8"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        clipRule="evenodd"
        d="M1.201 3.943c-.634-.709-1.65.37-.983 1.046.824.91 1.649 1.855 2.505 2.733.38.37.666.37 1.015 0L9.795 1.31C10.43.603 9.447-.477 8.781.231L3.262 6.102l-2.061-2.16z"
        fill="currentColor"
        fillRule="evenodd"
      />
    </svg>
  );
}
